module.exports = __webpack_public_path__ + "img/login.438e1af2.png";